import Salesforce from "../../../../contents/docs/cdp/sources/_snippets/source-salesforce.mdx";
import * as React from 'react';
export default {
  Salesforce,
  React
};